import React from "react";
import {  Grid  } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { useSelector } from "react-redux";
import { selectPaymentList, selectSecurityList, selectSpecialCircumstancesList } from "../selectors";
import DatePicker from "@commonComponents/formComponents/CustomDatePicker";

export const SecurityInfoForm=React.memo(({onSelect})=>{
  const security=useSelector(state=>state.transportReducer.security)
  const specificCircumstanceIndicator=useSelector(state=>state.transportReducer.specificCircumstanceIndicator)
  const presentationDate=useSelector(state=>state.transportReducer.presentationDate)
  const methodOfPayment=useSelector(state=>state.transportReducer.methodOfPayment)
  const paymentMethodList=useSelector(selectPaymentList)
  const securityList=useSelector(selectSecurityList)
  const specialcircumstancesList=useSelector(selectSpecialCircumstancesList)
 return (
            <Grid.Row>
          <Grid.Column>
          <DropDown
                id="security"
                label="SECURITY"
                name="security"
                data={securityList}
                clearable
                text={security}
                value={security}
                onChange={onSelect}
               />
          
          </Grid.Column>
          <Grid.Column>
          <DropDown
                id="specificCircumstanceIndicator"
                label="SPECIAL_CIRCUMSTANCES"
                name="specificCircumstanceIndicator"
                data={specialcircumstancesList}
                clearable
                boxNumber="1/7"
                text={specificCircumstanceIndicator}
                value={specificCircumstanceIndicator}
                onChange={onSelect}
            />
         
     
         
          </Grid.Column>
          <Grid.Column>
          
            <DatePicker
              id="presentation"
              name="presentationDate"
              type="date"
              mandatory={false}
              label="PRESENTATION"
              value={presentationDate} 
              onChange={onSelect}
              clearable
            />
          </Grid.Column>
          <Grid.Column>
          <DropDown
                id="paymentMethod"
                label="METHOD_OF_PAYMENT"
                name="methodOfPayment"
                clearable
                data={paymentMethodList}
                text={methodOfPayment}
                value={methodOfPayment}
                onChange={onSelect}
               />
         
              </Grid.Column>
        </Grid.Row>
        
      
    
  );
})